module.exports = __webpack_public_path__ + "img/pose-f-3.a332c2ce.png";